import { ReactNode } from 'react';
import { NsInput } from 'components/common/ns-input/NsInput';
import { NsInputter } from 'components/common/ns-inputter/NsInputter';
import { NsInputterValidations } from 'components/common/ns-inputter/NsInputterValidations';
import NsInputterEvent from 'components/common/ns-inputter/NsInputterEvent';

type Option = {
  label: React.ReactNode;
  value: string;
};

type NsRadioInputProps = {
  options: Option[];
  validation?: string[];
  value?: string | boolean;
  name?: string;
  onChange?: (event: NsInputterEvent) => void;
  dataTestId?: string;
  heading?: string;
  helper?: string;
  tipDetail?: ReactNode;
  className?: string;
  disabled?: boolean;
};

export const NsRadioInput = ({
  options,
  value,
  name,
  onChange,
  dataTestId,
  heading,
  helper,
  tipDetail,
  className,
  disabled
}: NsRadioInputProps) => {
  const validation = [NsInputterValidations.isRequired];

  return (
    <NsInputter
      className={className}
      name={name}
      data-testid={dataTestId}
      validation={validation}
      onChange={onChange}
      value={value}
      heading={heading}
      helper={helper}
      tipDetail={tipDetail}
    >
      {options.map(({ value, label }) => {
        const uniqueIdentifier = `${name}-${value}`;
        return (
          <NsInput
            type="radio"
            key={uniqueIdentifier}
            id={uniqueIdentifier}
            name={name}
            value={value}
            label={label}
            inputAttributes={{ disabled: disabled ?? false }}
          />
        );
      })}
    </NsInputter>
  );
};
